import z from 'zod';
import { fiscalRegionValue } from '../value-objects/fiscal-region';
export const firmBillingProfileSnapshotSchema = z.object({
    city: z.string().optional(),
    companyName: z.string().optional(),
    fiscalRegion: fiscalRegionValue.optional(),
    phoneNumber: z.string().optional(),
    postalCode: z.string().optional(),
    sirenNumber: z.string().optional(),
    streetName: z.string().optional(),
});
//# sourceMappingURL=firm-billing-profile-snapshot.js.map